import { makeStyles, Theme } from '@material-ui/core';

export const useStyles = makeStyles(
  ({ breakpoints, custom, palette, shape }: Theme) => ({
    controlContainer: {
      '&:not(:first-child)': {
        marginTop: 15,
      },
      position: 'relative',
      cursor: 'pointer',
      background: palette.common.white,
      padding: 5,
      paddingBottom: 20,
      paddingRight: 20,
      border: `1px solid ${custom.grey[1]}`,
      borderRadius: shape.borderRadius,
      [breakpoints.down(380)]: {
        paddingRight: 10,
      },
    },
    disabled: {
      cursor: 'not-allowed',
      pointerEvents: 'none',
    },
    error: {
      border: `4px solid ${custom.status.danger.contrastText}`,
    },
    installmentsApproved: {
      padding: '20px',
      backgroundColor: '#f1fbf5',
      marginTop: 15,
      fontSize: 14,
      display: 'flex',
      borderRadius: shape.borderRadius,
      border: 'solid 2px #8cdead',
      '& svg': {
        fill: '#4eb285',
      },
    },
    rejectedNew: {
      padding: '0 !important',
      '& $installmentsDetails': {
        paddingLeft: 12,
      },
      '& $column > $installMentsRrsoInfo': {
        padding: '12px 0 12px 36px',
      },
    },
    checkoutPaymentFormFlowInstallmentsApproved: {
      border: 'none',
      marginTop: 0,
      marginBottom: 12,
      display: 'flex',
      alignItems: 'center',
      padding: 15,
      '& svg': {
        marginRight: 15,
      },
    },
    installmentsApplicationNotFilled: {
      padding: '20px',
      backgroundColor: custom.status.danger.main,
      marginTop: 15,
      fontSize: 14,
      display: 'flex',
      borderRadius: shape.borderRadius,
      border: 'solid 2px #fff',
      '& svg': {
        fill: '#c10015',
      },
    },
    textWrapper: {
      marginLeft: 20,
      lineHeight: 1.43,
    },
    textWrapperCheckoutPaymentFlow: {
      '&>$title': {
        fontWeight: 700,
        fontSize: 16,
        lineHeight: '22px',
        color: custom.grey[3],
        '&>span': {
          fontWeight: 400,
        },
      },
    },
    title: {
      fontWeight: 'bold',
    },
    active: {
      border: `1px solid ${palette.primary.main}`,
      '& $radio': {
        color: palette.primary.main,
      },
    },
    activeNew: {
      backgroundColor: custom.status.warning.main,
      border: `solid 1px ${palette.primary.main} !important`,
    },
    installmentsDetails: {
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'wrap',
      alignItems: 'center',
      paddingLeft: 48,
      justifyContent: 'space-between',
    },
    noPadding: {
      padding: '0 0 0 0',
    },
    installMentsDetailsDesc: {
      marginBottom: 10,
    },
    noMargin: {
      margin: '0 0 0 0',
    },
    installMentsRrsoInfo: {
      paddingRight: 20,
      color: custom.grey[2],
      fontSize: 12,
      whiteSpace: 'pre-wrap',
    },
    installMentsRrsoInfoNew: {
      color: custom.grey[2],
      fontSize: 13,
      lineHeight: '20px',
      fontWeight: 400,
    },
    installMentsRrsoExpand: {
      textDecoration: 'underline',
    },
    mubiInstallmentsNewWrapper: {
      overflow: 'hidden',
      position: 'absolute',
      zIndex: 1,
      width: 80,
      height: 80,
      right: 0,
      top: 0,
    },
    mubiInstallmentsNewLabel: {
      position: 'absolute',
      transform: 'rotate(45deg)',
      padding: '8px 45px 6px 26px',
      marginTop: 20,
      textTransform: 'uppercase',
      fontSize: 10,
      fontWeight: 500,
      color: 'white',
      backgroundColor: '#f60',
    },
    greyBox: {
      paddingRight: 10,
      fontSize: 14,
      color: custom.grey[3],
      borderRadius: shape.borderRadius,
      width: 'fit-content',
      '&:not(:first-child)': {
        marginLeft: 15,
      },
      '&:first-of-type': {
        fontSize: 18,
      },
    },
    installmentsDetailsInline: {
      paddingLeft: 36,
      whiteSpace: 'normal',
    },
    installmentsDetails1: {
      display: 'inline',
      whiteSpace: 'nowrap',
      fontWeight: 700,
      fontSize: 16,
      lineHeight: '26px',
      color: custom.grey[3],
    },
    installmentsDetails2: {
      display: 'inline',
      whiteSpace: 'nowrap',
      fontWeight: 400,
      fontSize: 16,
      lineHeight: '26px',
      color: custom.grey[17],
      '&::before': {
        content: '"("',
      },
      '&::after': {
        content: '")"',
      },
    },
    buttonWrapper: {
      marginTop: 20,
    },
    checkoutPaymentFormFlowFooter: {
      '&>button': {
        width: 248,
        height: 50,
        borderRadius: '8px',
        fontSize: 16,
        fontWeight: 700,
        lineHeight: '22px',
        marginBottom: 12,
      },
    },
    column: {
      display: 'flex',
      alignItems: 'center',
    },
    wrapper: {
      fontSize: 14,
      fontWeight: 'bold',
      display: 'flex',
      alignItems: 'center',
      color: custom.grey[3],
      '& > span': {
        padding: 12,
      },
    },
    wrapperNew: {
      fontSize: 16,
      lineHeight: '26px',
      fontWeight: 400,
    },
    icon: {
      height: 48,
      width: 48,
      padding: 12,
      color: palette.primary.main,
    },
  })
);
